import { Decimal } from 'decimal.js';
export function triggerCsvDownload(filename: string, headers: string[], rows: any[][]) {
  const escapeCsvValue = (val: any) => {
    if (val === null || val === undefined) return '';
    const str = String(val);
    if (str.includes(',') || str.includes('"') || str.includes('\n')) {
      return `"${str.replace(/"/g, '""')}"`;
    }
    return str;
  };

  const content = [
    headers.map(escapeCsvValue).join(','),
    ...rows.map((r) => r.map(escapeCsvValue).join(',')),
  ].join('\n');

  const blob = new Blob([content], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.setAttribute('href', url);
  link.setAttribute('download', filename);
  link.click();
  URL.revokeObjectURL(url);
}

export function formatTdsFor26Q(items: any[]): { headers: string[]; rows: any[][] } {
  const headers = [
    'Deductee PAN',
    'Deductee Name',
    'Gross Amount',
    'TDS Amount',
    'Deduction Date',
    'Challan Number',
    'Challan Date',
    'Status',
  ];

  const rows = items.map((item) => [
    item.deducteePan || '',
    item.deducteeName || '',
    new Decimal(item.grossAmount).div(100).toFixed(2),
    new Decimal(item.tdsAmount).div(100).toFixed(2),
    item.deductionDate ? new Date(item.deductionDate).toLocaleDateString() : '',
    item.tdsChallanNo || '',
    item.tdsChallanDate ? new Date(item.tdsChallanDate).toLocaleDateString() : '',
    item.status || '',
  ]);

  return { headers, rows };
}

export function formatGstForGstr1(items: any[]): { headers: string[]; rows: any[][] } {
  const headers = [
    'Invoice Number',
    'Invoice Date',
    'Customer Name',
    'GSTIN',
    'Taxable Value',
    'CGST',
    'SGST',
    'IGST',
    'Total GST',
    'Status',
  ];

  const rows = items.map((item) => [
    item.invoiceNumber || '',
    item.invoiceDate ? new Date(item.invoiceDate).toLocaleDateString() : '',
    item.customerName || '',
    item.gstin || '',
    new Decimal(item.taxableValue).div(100).toFixed(2),
    new Decimal(item.cgstAmount).div(100).toFixed(2),
    new Decimal(item.sgstAmount).div(100).toFixed(2),
    new Decimal(item.igstAmount).div(100).toFixed(2),
    new Decimal(item.totalGst).div(100).toFixed(2),
    item.status || '',
  ]);

  return { headers, rows };
}
